import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component, EventEmitter,
    Input,
    OnDestroy,
    OnInit, Output,
    ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import {FuseCardComponent} from "@fuse/components/card";
import {User} from "app/core/types/smm/smm-person.types";
import {NgClass, NgIf} from "@angular/common";
import {PermissionsService} from "app/core/services/permissions.service";
import {MatIcon} from "@angular/material/icon";
import {TranslocoPipe} from "@ngneat/transloco";
import {MatTooltip} from "@angular/material/tooltip";
import {BreakpointObserver, BreakpointState} from "@angular/cdk/layout";

export enum WidgetSize {
    tiny, small,medium,large
}


@Component({
    selector: 'user-card-2',
    templateUrl: './user.card2.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        FuseCardComponent,
        NgIf,
        MatIcon,
        TranslocoPipe,
        MatTooltip,
        NgClass
    ],
})
export class UserCard2Component implements OnInit, OnDestroy {
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    @Input() size: WidgetSize = WidgetSize.tiny;
    selectedSize: WidgetSize = WidgetSize.tiny;
    @Input() user: User=null;
    @Output() stateEvtEmitter = new EventEmitter<string>();

    classMap = {
        0: {
            img: 'w-8 h-8 min-w-8 min-h-8',
            p:'px-2 py-1',
            title: 'text-md font-semibold',
            subTitle: "text-xs text-left text-secondary",
            card: 'mt-2'
        },
        1: {
            img: 'w-8 h-8 min-w-8 min-h-8',
            p:'px-2 py-1',
            title: 'text-lg font-semibold',
            subTitle: "text-md text-left text-secondary",
            card: ''
        },
        2: {
            img: 'w-16 h-16 min-w-16 min-h-16',
            p:'py-3 px-6',
            title: 'text-lg font-semibold',
            subTitle: "text-md text-left text-secondary",
            card: 'drop-shadow rounded-lg bg-card '
        },
        3: {
            img: 'w-24 h-24 min-w-24 min-h-24',
            p:'p-0',
            title: 'text-2xl font-semibold',
            subTitle: "text-md text-left text-secondary",
            card: 'drop-shadow rounded-full bg-card '
        },
    }

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        protected _permissionsService: PermissionsService,
        private breakpointObserver: BreakpointObserver
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // detect screen size changes
        this.breakpointObserver.observe([
            "(max-width: 600px)"
        ]).subscribe((result: BreakpointState) => {
            if (result.matches) {
                this.selectedSize = WidgetSize.tiny;
            } else {
                this.selectedSize = this.size;
            }
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


    search() {
        this.stateEvtEmitter.emit('search_user');
    }

    getCssClass(id:string){
        return this.classMap[this.selectedSize][id];
    }


    protected readonly WidgetSize = WidgetSize;
}
